import React from "react";
import { useDraggable } from "@dnd-kit/core";
import dayjs from "dayjs";
import { useProjectState } from "../../../../context/stateContext";
import "../index.css";

export function Draggable(props) {
  const {
    attributes,
    // listeners,
    setNodeRef,
    transform,
  } = useDraggable({
    id: props.id,
  });

  const { showSeatedTimeForReservationTable } = useProjectState();

  const style = {
    position: "absolute",
    transform: transform
      ? `translate3d(${props.position.x + transform.x}px, ${
          props.position.y + transform.y
        }px, 0)`
      : `translate3d(${props.position.x}px, ${props.position.y}px, 0)`,
    cursor: "move",
    width: "auto", // Maintain aspect ratio
    height: props.height,
    aspectRatio: props.aspectRatio,
  };

  let filter;
  if (props.isBusy) {
    // Gray
    filter =
      "brightness(0) saturate(100%) invert(80%) sepia(1%) saturate(0%) hue-rotate(284deg) brightness(88%) contrast(90%)";
  } else if (props.nextReservation) {
    const currentTime = dayjs();

    const parsedGivenTime = dayjs(
      `${currentTime.format("YYYY-MM-DD")}T${props.nextReservation}`
    );

    const oneHourLater = currentTime.add(1.5, "hour");

    const isWithinOneHour =
      // parsedGivenTime.isAfter(currentTime) &&
      parsedGivenTime.isBefore(oneHourLater);

    if (isWithinOneHour) {
      // Orange
      filter =
        "brightness(60%) saturate(100%) invert(98%) sepia(6%) saturate(1814%) hue-rotate(342deg) brightness(91%) contrast(97%)";
    } else {
      // Blue
      filter =
        "brightness(150%) saturate(100%) invert(86%) sepia(10%) saturate(1347%) hue-rotate(190deg) brightness(100%) contrast(95%)";
    }
  } else if (!props.isBusy) {
    // Blue
    filter =
      "brightness(150%) saturate(100%) invert(86%) sepia(10%) saturate(1347%) hue-rotate(190deg) brightness(100%) contrast(95%)";
  }

  function formatMinutesToTime(minutes) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    // Format hours and minutes to always be 2 digits
    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = remainingMinutes.toString().padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}`;
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      // {...listeners} // Disallow moving items
      className="reservations-draggable-container"
      onClick={(e) => {
        props.onTableClick(props.id);
      }}
    >
      <img
        src={props.src}
        alt={props.alt}
        style={{
          transform: `rotate(${props.direction}deg)`,
          transition: "transform 0.5s ease",
          filter: filter,
        }}
        className="reservations-table-image"
      />
      <div className="reservations-image">
        <span className="reservations-image-text">
          {showSeatedTimeForReservationTable
            ? props.tableOpenDurationInMinutes !== null
              ? formatMinutesToTime(props.tableOpenDurationInMinutes)
              : props.tableName
            : props.tableName}
        </span>
      </div>
    </div>
  );
}
